import {useToast} from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
const $toast = useToast();

const create = (message, type = 'success', position = 'top-right', duration = 3000, onclick) => {
  $toast.open({
    message: message,
    type: type,
    position: position,
    duration: duration,
    onClick: onclick,
  });
}

export const toast = {
  create
}
